<template>
  <b-container fluid>
    <template v-if="optionsLoaded && countries.length > 1">
      <b-select v-model="country" @change="switchOption();" class="mb-4">
        <b-select-option value="">Choose country...</b-select-option>
        <b-select-option v-for="c in countries" :key="c" :value="c">{{
          c
        }}</b-select-option>
      </b-select>
    </template>
    <activity-summary
      type="country"
      v-bind:id="country"
      :key="country"
    ></activity-summary>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ActivitySummary from '@/components/ActivitySummary';

export default {
  name: "CountryActivity",
  components: {
    ActivitySummary
  },
  data() {
    return {
      country: "",
      urlParams: new URLSearchParams(window.location.search),
      optionsLoaded: false,
    }
  },
  created() {
    this.getOptions();
    if (this.urlParams.get("country") !== null) {
      this.country = this.urlParams.get("country");
    }
  },
  methods: {
    ...mapActions({
      GET_OPTIONS: "optionsList/GET_OPTIONS",
      GET_TEAMS: "teams/GET_TEAMS",
    }),
    async getOptions() {
      try {
        await this.GET_OPTIONS();
        await this.GET_TEAMS();

        this.optionsLoaded = true;
      } catch (err) {
        console.error(err);
      }
    },
    setUrlParam(param, value) {
      this.urlParams.set(param, value);
      window.history.replaceState(
        {},
        "",
        `${location.pathname}?${this.urlParams}`
      );
    },
    deleteUrlParam(param) {
      this.urlParams.delete(param);
      window.history.replaceState(
        {},
        "",
        `${location.pathname}?${this.urlParams}`
      );
    },
    switchOption() {
      if (this.country) {
        this.setUrlParam("country", this.country);
      } else {
        this.deleteUrlParam("country");
      }
    }
  },
  computed: {
    ...mapGetters({
      isSRC: "auth/isSRC",
    }),
    countries: {
      get() {
        return (this.isSRC && this.$store.state.teams.teams && this.$store.state.teams.teams.length > 0)
          ? [... new Set(this.$store.state.teams.teams.map(team => team.country))]
          : this.$store.state.optionsList.countries.sort();
      }
    }
  }
};
</script>